import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mutateToAny', pure: true })
export class MutateToAnyPipe implements PipeTransform {
  transform(value: unknown, mutationFn: (target: unknown, context?: any) => {}, context?: any): any {
    return mutationFn(value, context);
  }
}
